import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { LoiSigningStatus } from '../models/loi-signing-status.model';

export interface GetLoiSigningStatusArg {
    engagementId: number;
    documentDetailsId: string;
}

export const GetLoiSigningStatus = createAsyncThunk(
    'loiSigning/getStatus',
    async (arg: GetLoiSigningStatusArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                `/api/Marketplace/Engagements/${arg.engagementId}/LoiSigning/${arg.documentDetailsId}`
            );

            if (response.status !== 200) {
                throw new Error('Failed to get the LOI signing status');
            }

            return response.data as LoiSigningStatus;
        } catch (error) {
            createNotification(
                'There was an error while getting the LOI signing status.',
                'error'
            );
            throw error;
        }
    }
);
